import { WeekdaySelection } from "../automated-desk-booking.component";

export function isAnyWeekdaySelected(
  selection: WeekdaySelection,
  bookingsOnSaturdaysAllowed: boolean | undefined,
  bookingsOnSundaysAllowed: boolean | undefined
): boolean {
  const weekdaysToCheck: (keyof WeekdaySelection)[] = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday"
  ];

  if (bookingsOnSaturdaysAllowed) {
    weekdaysToCheck.push("saturday");
  }

  if (bookingsOnSundaysAllowed) {
    weekdaysToCheck.push("sunday");
  }

  return weekdaysToCheck.some(day => selection[day] === true);
}
